import { render, staticRenderFns } from "./boards_selector.vue.js?vue&type=template&id=2dda2dda&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./boards_selector.vue?vue&type=template&id=2dda2dda&vue3"
import script from "./boards_selector.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./boards_selector.vue?vue&type=script&lang=js&vue3"
export * from "./boards_selector.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./boards_selector.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports